import {Box} from "@mui/material";
import {DetailsHeader} from "./DetailsHeader";

export interface DetailsTableProps {
    header?: React.ReactNode;
    children: React.ReactNode;
    prologue?: React.ReactNode;
    epilogue?: React.ReactNode;
}

export function DetailsTable(props: Readonly<DetailsTableProps>) {
    return (
            <Box minWidth={"sm"}>
                <Box mb={2}>
                    {props.header &&
                            <DetailsHeader>{props.header}</DetailsHeader>
                    }
                    {props.prologue &&
                            <Box mb={2}>{props.prologue}</Box>
                    }
                    <table width={"100%"} className={"DetailsTable"}>
                        {props.children}
                    </table>
                    {props.epilogue &&
                            <Box mt={2}>{props.epilogue}</Box>
                    }
                </Box>
            </Box>
    );
}
